<template>
    <tr>
        <td>
            <h3><a :href="booking.tracking_url">{{ booking.id }}</a></h3>
            <p><strong>Placed:</strong><br>
                {{ booking.placed_at }}
            </p>
        </td>
        <td>
            <strong>{{ booking.pickup_location.name }}</strong><br>
            {{ booking.pickup_location.street }},<br>
            {{ booking.pickup_location.suburb }},<br>
            {{ booking.pickup_location.district }}<br>
            <p><strong>After:</strong><br>
                {{ booking.pickup_at }}
            </p>
        </td>
        <td>
            <strong>{{ booking.deliver_location.name }}</strong><br>
            {{ booking.deliver_location.street }},<br>
            {{ booking.deliver_location.suburb }},<br>
            {{ booking.deliver_location.district }}<br>
            <p><strong>After:</strong><br>
                {{ booking.deliver_at }}
            </p>
        </td>
        <td>
            <table class="table table-striped">
                <tr v-for="freight in booking.freights">
                    <td>{{ freight.quantity }}</td>
                    <td>
                        {{ freight.package_type }}<br>
                        <i>({{ freight.goods_type }})</i>
                    </td>
                    <td>{{ Math.trunc(freight.weight) }}Kgs</td>
                    <td>{{ freight.volume }}m<sup>3</sup></td>
                </tr>
                <tr>
                    <td colspan="2"><strong>Total:</strong></td>
                    <td>{{ Math.trunc(booking.weight) }}Kgs</td>
                    <td>{{ booking.volume }}m<sup>3</sup></td>
                </tr>
            </table>
        </td>
        <td>
            <p><strong>Carrier:</strong><br>
                <span v-if="booking.status_id >= 3">{{ booking.carrier }}</span>
                <span v-else>
                    Pending
                </span>
            </p>
        </td>
        <td>
            <a v-if="booking.carrier !== 'Aramex'" style="margin-bottom:4px" class="btn btn-primary btn-sm btn-block" :href="'/send-freight/bookings/' + booking.id + '/all'" target="_blank">All Files</a>
            <a style="margin-bottom:4px" class="btn btn-primary btn-sm btn-block" :href="'/send-freight/bookings/' + booking.id + '/consignment'" target="_blank">Con note</a>
            <a style="margin-bottom:4px" class="btn btn-primary btn-sm btn-block" :href="'/send-freight/bookings/' + booking.id + '/address-label'" target="_blank">Address label</a>
            <a v-if="booking.is_dg > 0" style="margin-bottom:4px" class="btn btn-primary btn-sm btn-block" :href="'/send-freight/bookings/' + booking.id + '/dgs'" target="_blank">DGs</a>
            <a v-if="booking.has_pod" style="margin-bottom:4px" class="btn btn-primary btn-sm btn-block" :href="'/send-freight/bookings/' + booking.id + '/proof-of-delivery'" target="_blank">Proof of delivery</a>
        </td>
    </tr>
</template>

<script>
    export default {
        name: 'network-booking-item',
        props: ['booking'],
    }
</script>
